import React from 'react';
import { BoxIcon, CalculatorIcon, DrillIcon, HammerIcon, HouseIcon, RulerIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  hammer: HammerIcon,
  ruler: RulerIcon,
  drill: DrillIcon,
  box: BoxIcon,
  house: HouseIcon,
  calculator: CalculatorIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-red-600', 'bg-blue-700', 'bg-green-700', 'bg-orange-600', 'bg-purple-700', 'bg-teal-700'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-charcoal" data-id="element-165" data-mp="atmf2zk1rl0q">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-166" data-mp="5wcfws6uvuzp">
        <p className="font-display text-xs font-bold uppercase tracking-widest text-cta" data-id="element-167" data-mp="ksbt2h8tolbp">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-168" data-mp="fre4nmx7yv1r">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1 font-display text-xs font-black uppercase leading-tight text-cta sm:text-sm" data-id="element-169" data-mp="3fbk65z78avjw">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/80" data-id="element-170" data-mp="3kb6i85bbm5r4">
          No es simplemente otro ebook de carpintería. Es una ruta de
          aprendizaje que organiza los conocimientos fundamentales para que
          comprendas qué aprender primero, cómo diseñar tus muebles y cómo pasar
          de un plano a un proyecto terminado.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-171" data-mp="6w0hldhi61b6">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg bg-cream-light text-left text-charcoal" data-id="element-172" data-mp="bsh648sm6hos" data-mpi={i}>
                <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-1 text-white ${TOMO_COLORS[i]}`} data-id="element-173" data-mp="27y8e2dklent6">
                  <span className="font-display text-xs font-bold uppercase tracking-wider" data-id="element-174" data-mp="2mofms1ksssgo">
                    Tomo
                  </span>
                  <span className="font-anton text-3xl leading-none" data-id="element-175" data-mp="2vmj74uk1rj6w">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-176" data-mp="2rkxr50c7uosh" />
                </span>
                <div className="p-2.5" data-id="element-177" data-mp="35lqm1m6fjlw4">
                  <h3 className="sr-only" data-id="element-178" data-mp="35kp6b4egyb82">Tomo {i + 1}</h3>
                  <p className="font-display text-sm font-extrabold uppercase leading-tight" data-id="element-179" data-mp="30m44x1nhdli1">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-xs leading-snug text-charcoal/80 sm:text-sm" data-id="element-180" data-mp="1b9k0pujtnoq3">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-181" data-mp="3mujfupiarmi5">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}